import React, { useState, useEffect } from "react";
import ConfirmPopUp from './ConfirmPopUp.js';
import Button from '../Button/Button.js';
import Scroll from "../Scroll/Scroll.jsx";

const CheckList = props => { 
    const [showConfirm, setShowConfirm] = useState(false);
    // useEffect(()=>{
    //     console.log(props.clickedCheckboxes, props.correctCheckBoxes)
    // },[])  

    let selectedCorrect = (a,b) =>{
        console.log(a,b)
        if( a && a === b){
            return "correct"
        }else if(b && a !== b){
            return "wrong"
        }else{
            return ""
        }
    }
    return(
        <div className={`CheckList-container`}>
            <div className={`checklist`}>
                
                <div className={`checklist-body`}>
                    <div className={`checklist-form`}>
                        <div className={`checklist-header`}>
                            <h3>Checklist</h3>
                        </div>
                        <Scroll>
                        <div className="scroll-content">
                        {props.pageState === "checklist"?
                            <>
                                <ul>
                                {props.clickedCheckboxes.length > 0 &&
                                    props.capabilities.map((industry, index) => {
                                        return (
                                            <li className={`main-li`}>
                                                <div className="check-container">
                                                    <label>{industry.header}
                                                        <input onClick={() => props.handleCheckboxClick(index, 0)} checked={props.clickedCheckboxes[index][0]} type="checkbox" />
                                                        <span className="checkmark"></span>
                                                    </label>
                                                </div>
                                                <ul>
                                                    {industry.subCapabilities.map((subCapability, subIndex) => {
                                                        return(
                                                            <li>
                                                                <div className="check-container">
                                                                    <label>{subCapability.header}
                                                                        <input onClick={() => props.handleCheckboxClick(index,subIndex + 1)} checked={props.clickedCheckboxes[index][subIndex + 1]} type="checkbox" />
                                                                        <span className="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                        </li>
                                                        )
                                                    })}
                                                </ul>
                                            </li>
                                        )
                                    })
                                
                                }                                          
                                </ul>
                            </>
                            :
                            <>
                                <ul>
                                    {props.clickedCheckboxes.length > 0 &&
                                        props.capabilities.map((industry, index) => {
                                            return (
                                                <li className={`main-li`}>
                                                    <div style={{"pointerEvents": 'none'}} className="check-container">
                                                        <label>{industry.header}
                                                            <input onClick={() => props.handleCheckboxClick(index, 0)} disabled={true} checked={props.clickedCheckboxes[index][0]} type={`checkbox`} />
                                                            {/* <span className={`checkmark ${selectedCorrect(props.correctCheckBoxes[index][index], props.clickedCheckboxes[index][index])}`}></span> */}
                                                            <span className={`checkmark`}></span>

                                                        </label>
                                                    </div>
                                                    {industry.subCapabilities.map((subCapability, subIndex) => {
                                                        return(
                                                            <li>
                                                                <div style={{"pointerEvents": 'none'}} className="check-container">
                                                                    <label>{subCapability.header}
                                                                        <input onClick={() => props.handleCheckboxClick(index,subIndex + 1)} disabled={true} checked={props.clickedCheckboxes[index][subIndex + 1]} type={`checkbox`} />
                                                                        {/* <span className={`checkmark ${selectedCorrect(props.correctCheckBoxes[index][subIndex +1], props.clickedCheckboxes[index][subIndex + 1])}`}></span> */}
                                                                        <span className={`checkmark`}></span>
                                                                    </label>
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                                </li>
                                            )
                                        })
                                    }                                          
                                </ul>
                            </>
                        }
                        </div>
                        </Scroll>
                    </div>
                </div>
            </div>
            {props.pageState === "checklist"&&
                <div className={`form-footer`}>
                    {/* <button className={`submit`} onClick={()=>setShowConfirm(!showConfirm)}>Submit</button> */}
                    {/* <Button text="Submit" onClick={()=>setShowConfirm(!showConfirm)}/> */}
                    <Button text="Submit" onClick={()=>props.setPageState('benchmarkingquiz')}/>
                </div>
            }
            {/* {showConfirm &&
                <ConfirmPopUp onClose={()=>setShowConfirm(!showConfirm)} onComplete={()=>props.setPageState('teamcheckin')}  />
            } */}
        </div>
    )
}

export default CheckList